import { c as _c } from "react/compiler-runtime";
import ArchivesHero from "@/components/archives/ArchivesHero";
import ArchivesAbout from "@/components/archives/ArchivesAbout";
import ArchiveSections from "@/components/archives/ArchiveSections";
import ArchiveExplorer from "@/components/archives/ArchiveExplorer";
import CommunitySubmission from "@/components/archives/CommunitySubmission";
import SeoHead from "@/components/seo/SeoHead";
import { breadcrumbJsonLd, seoFromPage } from "@/lib/seo";
export default function ArchivesPage() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = seoFromPage("archives");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const seo = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><SeoHead {...seo} jsonLd={breadcrumbJsonLd([{
        name: "Home",
        path: "/"
      }, {
        name: "Archives",
        path: "/archives"
      }])} /><main><ArchivesHero /><ArchivesAbout /><ArchiveSections /><ArchiveExplorer /><CommunitySubmission /></main></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}